var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1616408846320,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 1122,
    width: 48,
    height: 48,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 0C229.23264 0 0 229.21216 0 512s229.23264 512 512 512c282.76736 0 512-229.23264 512-512S794.76736 0 512 0zM764.17024 685.24032c-14.78656 4.42368-32.44032-4.42368-47.22688-22.1184-8.84736 16.22016-19.16928 32.44032-30.96576 47.2064 33.8944 8.86784 57.5488 29.47072 57.5488 53.08416 0 33.91488-47.22688 61.91104-104.71424 61.91104-42.76224 0-81.08032-16.22016-95.8464-38.33856-10.3424 1.47456-19.18976 2.99008-28.01664 2.99008-8.88832 0-17.7152-1.47456-28.03712-2.99008-14.72512 22.1184-53.08416 38.33856-95.8464 38.33856-57.52832 0-104.67328-27.99616-104.67328-61.91104 0-23.57248 23.59296-44.21632 57.48736-53.08416-13.23008-16.19968-23.552-33.91488-32.44032-51.63008-16.19968 20.64384-35.36896 30.96576-51.6096 26.54208-27.99616-8.84736-35.40992-66.3552-17.67424-126.79168 14.72512-45.69088 41.28768-81.08032 64.88064-92.89728-4.44416-16.22016-7.39328-33.91488-7.39328-53.08416C299.6224 294.5024 396.98432 198.656 514.94912 198.656c117.94432 0 215.28576 95.8464 215.28576 213.8112 0 20.64384-2.99008 38.31808-7.39328 56.0128 22.1184 13.27104 44.2368 47.18592 59.00288 89.96864C799.51872 618.88512 792.18688 676.39296 764.17024 685.24032z",
    "p-id": 1123,
    fill: "#1296db"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQq);
export default __webpack_public_path__ + "static/media/QQ.66200caa.svg";
export { ForwardRef as ReactComponent };